import moment from 'moment';
import corporateSettings from 'corporateSettings.json';
import { addMonthsByModality } from './policyModality';

export const getPreviousMonthlyPeriodStart = (expirationDate) =>
  expirationDate.clone().subtract(1, 'months').set('date', expirationDate.date());

export const getPolicyValidityEnd = ({ createdAt, expirationDate, modality }) =>
  modality === 'monthly' ? moment.utc(expirationDate) : addMonthsByModality(createdAt, modality);

export const shouldUseAnnualCoverageValidity = ({ partnerId, modality }) => {
  const partnerSettings = corporateSettings.find(({ id_partner }) => Number(id_partner) === Number(partnerId));

  return modality === 'annual' && partnerSettings?.use_annual_coverage_validity === true;
};

export const resolveCoverageValidityPeriod = ({
  partnerId,
  modality,
  policyStart,
  policyEnd,
  defaultCoverageStart,
  defaultCoverageEnd,
}) => {
  if (shouldUseAnnualCoverageValidity({ partnerId, modality })) {
    return { start: policyStart, end: policyEnd };
  }

  return { start: defaultCoverageStart, end: defaultCoverageEnd };
};
